import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import HeroText from "../components/hero-text"
import FullWidthMailList from "../components/mailing-list-full"
import SocialBanner from "../components/social-banner"
import UpcomingEvents from "../components/upcoming-events"
import RecentNews from "../components/recent-news"

const IndexPage = () => (
  <Layout>
    <SEO title="Thriving Madly" />
    <HeroText textQuote="Celebrating lives lived outside the box."/>
    <FullWidthMailList />
    <SocialBanner />
    <div className="row my-5 w-100">
      <div className="col-md pr-md-4">
        <UpcomingEvents />
      </div>
      <div className="col-md pl-5 pl-md-0">
        <RecentNews />
      </div>
    </div>
  </Layout>
)

export default IndexPage
